<template>
	<div id="modal-common-product-preview">
		<b-modal :id="modalName" hide-footer size="xl">
            <template v-slot:modal-title>
                Product Preview ({{ sku }})
            </template>

            <b-row>
                <b-col cols="6">
                    <b-table-simple hover small responsive bordered>
                        <b-tbody>
                            <b-tr>
                                <b-td class="text-center" colspan="4"><h5>{{ item.name }}</h5></b-td>
                            </b-tr>
                            <b-tr>
                                <b-th>Category</b-th>
                                <b-td>{{ item.category && item.category.name }}</b-td>
                                <b-th>SKU</b-th>
                                <b-td>{{ item.sku }}</b-td>
                            </b-tr>
                            <b-tr>
                                <b-th>Product ID</b-th>
                                <b-td>{{ item.id }}</b-td>
                                <b-th>Sales Price</b-th>
                                <b-td>{{ item.price }}</b-td>
                            </b-tr>
                            <b-tr>
                                <b-th>Build With</b-th>
                                <b-td></b-td>
                                <b-th>Weighted Cost</b-th>
                                <b-td></b-td>
                            </b-tr>
                            <b-tr>
                                <b-th>Total Stock</b-th>
                                <b-td>{{ item.qty_total }}</b-td>
                                <b-th>Latest Cost</b-th>
                                <b-td></b-td>
                            </b-tr>
                            <b-tr>
                                <b-th>WH (A)</b-th>
                                <b-td>{{ item.qty_wh_a }}</b-td>
                                <b-th>BIN (A)</b-th>
                                <b-td>{{ item.bin_a }}</b-td>
                            </b-tr>
                            <b-tr>
                                <b-th>WH (B)</b-th>
                                <b-td>{{ item.qty_wh_b }}</b-td>
                                <b-th>BIN (B)</b-th>
                                <b-td>{{ item.bin_b }}</b-td>
                            </b-tr>
                            <b-tr>
                                <b-th>QTY Available</b-th>
                                <b-td>{{ item.qty_available || 0}}</b-td>
                                <b-th>QTY On Orders</b-th>
                                <b-td>{{ item.qty_ordered || 0 }}</b-td>
                                <!-- <b-td><b-link @click="openModal('modal-inventory-products-show-open-orders', item.sales_order_lines)">{{ item.qty_ordered || 0 }}</b-link></b-td> -->

                            </b-tr>
                                <b-th>Open Orders</b-th>
                                <b-td v-if="item && item.sales_order_lines">{{ calculateOpenOrders(item.sales_order_lines) }}</b-td>
                                <!-- <b-td colspan="3"><b-link @click="openModal('modal-inventory-products-show-open-orders', item.sales_order_lines)"><span v-if="item != ''">{{ calculateOpenOrders(item.sales_order_lines) || 0}}</span></b-link></b-td> -->
                            <b-tr>
                                <b-th>Tags</b-th>
                                <b-td colspan="3">{{ tags }}</b-td>
                            </b-tr>
                            <b-tr>
                                <b-th>Attributes</b-th>
                                <b-td colspan="3">{{ attributes }}</b-td>
                            </b-tr>
                            <b-tr>
                                <b-th>Total QTY Sold</b-th>
                                <b-td colspan="3"></b-td>
                            </b-tr>
                            <b-tr>
                                <b-th>Net Revenue Generated</b-th>
                                <b-td colspan="3"></b-td>
                            </b-tr>
                            <b-tr>
                                <b-th colspan="4">Short Description</b-th>
                            </b-tr>
                            <b-tr>
                                <b-td colspan="4">{{ item.description }}</b-td>
                            </b-tr>
                        </b-tbody>
                    </b-table-simple>
                </b-col>

                <b-col cols="6">
                    <b-row v-if="item && item.item_image && item.item_image.length">
                        <b-col class="text-center main-image">
                            <b-img v-if="item" :src="getImageUrl(item.sku, 'MEDIUM', currentImage, currentExtension) + '?rnd=' + cacheKey"></b-img>
                        </b-col>

                        <b-col class="text-center thumbnails" cols="2">
                            <b-img @click="currentImage = img.sequence; currentExtension = img.extension" v-for="(img, index) in item.item_image" :key="index + '?rnd=' + cacheKey" :src="getImageUrl(item.sku, 'SMALL', img.sequence, img.extension) + '?rnd=' + cacheKey" @error="$event.target.src = ''"></b-img><br />
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </b-modal>
	</div>
</template>

<script>
	export default {
		props: [
            'sku'
		],

		components: {

		},

		data() {
			return {
				modalName: 'modal-common-product-preview',
                item: [],
                attributes: '',
                tags: '',
                cacheKey: 0,
                lists: {
                    attributes: []
                }
			}
		},

		methods: {
            getTags() {
                let url = 'api/inventory/products/gettagsfilter'
                axios.get(url, {})
                .then((res) => {
                    this.modals['modal-inventory-products-edit-product'].tags = res.data.tags
                }, () => {
                    this.has_error = true
                })
            },

            getAttributes() {
                let url = 'api/inventory/products/getattributesfilter'
                axios.get(url, {})
                .then((res) => {
                    this.lists.attributes = res.data.attributes
                    this.getRow()
                }, () => {
                    this.has_error = true
                })
            },

            getCategories() {
                let url = 'api/inventory/products/getcategoriesfilter'
                axios.get(url, {})
                .then((res) => {
                    this.modals['modal-inventory-products-edit-product'].categories = res.data.categories
                }, () => {
                    this.has_error = true
                })
            },

            getVendors() {
                let url = 'api/inventory/products/getvendorsfilter'
                axios.get(url, {})
                .then((res) => {
                    this.modals['modal-inventory-products-edit-product'].vendors = res.data.vendors
                }, () => {
                    this.has_error = true
                })
            },

            getRow() {
                let url = 'api/inventory/products/getproduct/' + this.sku
                axios.get(url, {})
                .then((res) => {
                    this.item = res.data.items
                    this.currentImage = res.data.items.item_image[0] != undefined ? res.data.items.item_image[0].sequence : null
                    this.currentExtension = res.data.items.item_image[0] != undefined ? res.data.items.item_image[0].extension : null

                    // this.tables.notes.items = res.data.items.item_note

                    if (res.data.items.item_attribute) {
                        this.attributes = ''
                    	res.data.items.item_attribute.forEach((attribute, idx, array) => {
                    		if (idx === array.length - 1) {
                    			this.attributes += this.findAttributeName(attribute.attributes_id) + ': ' + attribute.item_attribute_option.attribute_option.value
                    		} else {
                    			this.attributes += this.findAttributeName(attribute.attributes_id) + ': ' + attribute.item_attribute_option.attribute_option.value + ' | '
                    		}
                    	})
                    }

                    if (res.data.items.tags) {
                        this.tags = ''
                        res.data.items.tags.forEach((tag, idx, array) => {
                        	if (idx === array.length - 1) {
                            	this.tags += tag.tag.name
                            } else {
                            	this.tags += tag.tag.name + ' | '
                            }
                        })
                    }
                }, () => {
                    this.has_error = true
                })
            },

            findAttributeName(id) {
                let index = this.findIndex(this.lists.attributes, 'id', id)
                return this.lists.attributes[index].name
            },
		},

		computed: {

		},

		mounted() {
            this.getAttributes()
        	// this.getCategories()
        	// this.getVendors()
        	// this.getTags()
        	// this.getRow()
		}
	}
</script>
<style lang="scss">
    #modal-common-product-preview {
        // .modal-dialog {
        //     width: 250px;
        // }

        .main-image img, .thumbnails img {
            width: 100%;
        }
    }
</style>
